//
// # Style Type Definitions
//

// Local Imports
import { Color } from "./color";
import { Table } from "./table";

// The font for, well, everything
const f = "Menlo, Monaco, 'Courier New', monospace";
export const THE_FONT = f;

// Enumerated special styles
export enum Special {
  None = "None", // "Don't have this", whatever that means in context
}

// Styling for shapes
export interface ShapeStyle {
  hidden?: boolean; // Visibility. Defaults to visible if not specified.
  cap: "butt" | "round" | "square";
  join: "bevel" | "round" | "miter";
  linewidth: number;
  lineDash?: Array<number>;
  // "None-able" values
  fill?: Color | Special.None;
  stroke?: Color | Special.None;
}

// Styling for shapes
export type ShapeStyleTable = Table<ShapeStyle>;

// Styling for text elements
export interface TextStyle {
  hidden?: boolean; // Visibility. Defaults to visible if not specified.
  family: string;
  style: "normal" | "italic";
  weight: number;
  size: number;
  // "None-able" values
  fill?: Color | Special.None;
  stroke?: Color | Special.None;
}

export type TextStyleTable = Table<TextStyle>;

// # Style
// Combination of shapes and text
export interface Style {
  shape: ShapeStyle;
  text: TextStyle;
}

// Style Table
export type StyleTable = Table<Style>;
